import { SelectableAgreement } from "../../processingActivity/ProcessingActivity.types.ts";
import { ContractStatus } from "../Contracts.types.ts";

export enum AutoRenewalDurationType {
    Months = 1,
    Years = 2,
}

export class ContractModel {
    name: string | undefined;
    description: string | undefined;
    userFriendlyId: number | undefined;
    referenceNumber: string | undefined;
    contractTypeId: string | undefined;
    entityTemplateId: string | undefined;
    note: string | undefined;
    businessAreas: Array<string> = [];
    contractAccessBusinessAreas: Array<string> = [];
    contractManagerId: string | undefined;
    visibleToAllUsers: boolean = false;
    allGroupEntityAccess: boolean = true;
    groupEntities: Array<string> = [];
    startDate: Date | undefined;
    endDate: Date | undefined;
    signatureDate: Date | undefined;
    contractExpiryNotificationInDays: number | undefined;
    totalAmount: number | undefined;
    finalizedAmount: number | undefined;
    currencyCode: string | undefined;
    paymentTermId: string | undefined;
    specialTerms: string | undefined;
    counterParties: Array<CounterPartyViewModel> = [];
    hasAccessToMultipleGroupEntities: boolean = false;
    hasDocuments: boolean = false;
    additionalAccessUsers: Array<string> = [];
    excludedUsers: Array<string> = [];
    customFieldValues: Array<CustomFieldValue> = [];
    status: ContractStatus | undefined;
    autoRenewalDuration: number | undefined;
    autoRenewalDurationType: number | undefined;
}

export interface CustomFieldValue {
    customInputFieldId: string;
    value: any; // The raw JSON value
}

export interface CounterPartyViewModel {
    id: string;
    legalEntityId?: string;
    subContractors: Array<CounterPartySubContractorViewModel>;
}

export interface CounterPartySubContractorViewModel {
    id: string;
    counterPartyId: string;
    legalEntityId?: string;
    link?: string;
    isLink: boolean;
    hasAgreement: boolean;
}

export interface CounterPartyUpdateModel {
    legalEntityId?: string;
}

export interface ContractUpdateModel {
    name?: string;
    description?: string;
    referenceNumber?: string;
    contractTypeId: string;
    note?: string;
    businessAreas: Array<string>;
    contractAccessBusinessAreas: Array<string>;
    contractManagerId?: string;
    visibleToAllUsers: boolean;
    allGroupEntityAccess: boolean;
    groupEntities: Array<string>;
    startDate?: Date;
    endDate?: Date;
    signatureDate?: Date;
    contractExpiryNotificationInDays?: number;
    totalAmount?: number;
    finalizedAmount?: number;
    currencyCode?: string;
    paymentTermId?: string;
    specialTerms?: string;
    additionalAccessUsers: Array<string>;
    excludedUsers: Array<string>;
    autoRenewalDuration?: number;
    autoRenewalDurationType?: number;
    status?: ContractStatus;
}

export interface ContractOnTransfer {
    contractIds: Array<string>;
    containsNonAccessibleContacts: boolean;
}

export interface SelectableContract {
    id: string;
    name: string;
    contractTypeName?: string;
    contractTemplateName?: string;
}

export function toSelectableAgreement(selectedContract: SelectableContract): SelectableAgreement {
    return {
        type: "contract",
        name: selectedContract.name,
        contractOrDocumentType: selectedContract.contractTypeName ?? "",
        id: selectedContract.id,
    };
}
